export default "__VITE_ASSET__DQ14VXkO__"